import { Observable } from 'rxjs';
import { HttpOptions } from './http-options';

export interface IHttpClient {
  get<TResponse>(absoluteUrl: string, options?: HttpOptions): Observable<TResponse>;
  post<TResponse, TBody>(absoluteUrl: string, body: TBody, options?: HttpOptions): Observable<TResponse>;
  put<TResponse, TBody>(absoluteUrl: string, body: TBody, options?: HttpOptions): Observable<TResponse>;
  delete<TResponse>(absoluteUrl: string, options?: HttpOptions): Observable<TResponse>;
  patch<TResponse, TBody>(absoluteUrl: string, body: TBody, options?: HttpOptions): Observable<TResponse>;
}
